// Angular
import { Component, Output, Input, ViewChild, ElementRef, HostListener, EventEmitter, OnInit } from '@angular/core';
// External
import { AngularFireDatabase } from 'angularfire2/database';
import { Subject } from 'rxjs';
import { async } from '@angular/core/testing';
import { ApiService } from 'app/services/api';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})

export class TextEditorComponent implements OnInit {

  @ViewChild('textarea') textarea: ElementRef;
  @Output() onChange: EventEmitter<any>;
  @Input() parentSubject: Subject<any>;

  public text: string;
  public query: string;
  public users: Array<any>;
  public selectedUsers: Array<any>;
  public activeIndex: number;
  public deleteIndex: number;

  private typingDelay: any;

  constructor(private apiService: ApiService, private fireDatabase: AngularFireDatabase) {
    this.onChange = new EventEmitter();

    this.users = [];
    this.selectedUsers = [];
    this.activeIndex = -1;
    this.deleteIndex = -1;
  }

  @HostListener('window:keydown', ['$event'])
  keyDown(event: KeyboardEvent) {
    if (event.keyCode === 37 || event.keyCode === 39) {
      this.query = '';
    }

    if (event.keyCode === 40) {
      event.preventDefault();

      if (this.activeIndex < this.users.length - 1) {
        this.activeIndex++;
      }
    }

    if (event.keyCode === 38) {
      event.preventDefault();

      if (this.activeIndex > 0) {
        this.activeIndex--;
      }
    }

    if (event.keyCode === 13) {
      if (this.activeIndex !== -1) {
        event.preventDefault();

        this.addUser(this.users[this.activeIndex]);
      }
    }
  }
  ngOnInit() {


    if (this.parentSubject) {
      this.parentSubject.subscribe(async (event) => {
        console.log(event);
        if (event.text) {
          this.text = event.text

        }
        if (!event.text)
        {
          this.text = "";
          this.selectedUsers = []
          }
        if (event.mentioned) {
          for (let p = 0; p < Object.keys(event.mentioned).length; p++) {
            const userId = Object.keys(event.mentioned)[p];
            let user = await this.apiService.object("users/" + userId)
            this.selectedUsers.push(user)
          }
        }
      })

    }
  }

  addUser(user) {
    const endMentionText = this.textarea.nativeElement.selectionStart;
    const startMentionText = endMentionText - (this.query.length + 1);
    const startText = this.text.slice(0, startMentionText);
    const endText = this.text.slice(endMentionText).replace(/^\s+/, '');
    const replaceText = `@${user.username}`;
    let isAlready = this.selectedUsers.find(u => u.$key == user.$key)
    if (!isAlready)
      this.selectedUsers.push(user);
    this.text = `${startText}${replaceText} ${endText}`;
    this.activeIndex = -1;
    this.query = '';

    setTimeout(() => {
      this.textarea.nativeElement.selectionStart = startText.length + replaceText.length + 1;
      this.textarea.nativeElement.selectionEnd = startText.length + replaceText.length + 1;
    });

    this.checkMentioned();
    this.onChange.emit({
      mentioned: this.selectedUsers,
      text: this.text
    });
    this.textarea.nativeElement.focus()
  }

  checkMentioned() {
    if (!this.text) {
      return;
    }

    const mentioned = this.text.match(/(?:@)(\w+)/g);

    if (!mentioned || !mentioned.length) {
      this.selectedUsers = []
      return;
    }

    this.selectedUsers.forEach((user, index) => {
      const username = `@${user.username}`;
      if (mentioned.indexOf(username) < 0) {
        this.selectedUsers.splice(index, 1);
      }
    });
  }

  searchMention(query: string) {
    if (query.search("@") != -1) {
      this.query = query.split('@')[query.split('@').length - 1].toLowerCase().trim();
      console.log(this.query);

      this.fireDatabase.list('/users', {
        query: {
          orderByChild: 'username',
          startAt: this.query,
          limitToFirst: 7
        }
      })
        .subscribe((result: Array<any>) => {
          this.users = []
          result.forEach(element => {
            if (element.username.indexOf(this.query) > -1)
              this.users.push(element)
          });
          // this.users = result;
          console.log(this.users);

        });
    }

  }

  typing() {
    const regexMention = /(?:@)(\w+)/g;
    const cursorPosition = this.textarea.nativeElement.selectionStart;
    const value = this.text.slice(0, cursorPosition);
    const words = value.split(' ');

    this.query = '';

    if (words && words.length) {
      const lastWord = words[words.length - 1];

      if (lastWord.match(regexMention)) {
        clearTimeout(this.typingDelay);

        this.typingDelay = setTimeout(() => {
          this.searchMention(lastWord);
        }, 400);
      }
    }

    this.checkMentioned();
    this.onChange.emit({
      mentioned: this.selectedUsers,
      text: this.text
    });
  }
}
